// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Card_cardContainer__ITsGz"};